import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "sort-by-form",
  class SortByForm extends WYATTElement {
    constructor() {
      super();

      this.addEventListener("input", this.handleInput);
    }

    handleInput(event) {
      const formID = event.target.getAttribute("form");
      const form = document.getElementById(formID);
      const sortByChanged = new CustomEvent("input");

      form.dispatchEvent(sortByChanged);
    }
  }
);
